import React from 'react';
import classNames from 'classnames';

import './carousel-thumb-item.scss';

interface CarouselThumbItemProps {
    image: string;
    alt: string;
    index: number;
    totalPhotos: number;
    onClick?: (index: number) => void;
    modalCarousel?: boolean;
}

const CarouselThumbItem: React.FC<CarouselThumbItemProps> = ({
    totalPhotos,
    image,
    alt,
    index,
    onClick,
    modalCarousel = false
}) => {
    const showMoreInfo = index === 3 && totalPhotos > 4;

    return (
        <div
            className={classNames({
                'thumb__item': true,
                'thumb__item--more': (showMoreInfo && !modalCarousel)
            })}
            onClick={() => showMoreInfo && onClick && onClick(index)}
        >
            {(showMoreInfo && !modalCarousel) && (
                <div className="thumb__item__more-text">
                    + {totalPhotos - 4}
                </div>
            )}
            <img
                src={image}
                alt={alt}
                height="50"
                width="50"
            />
        </div>
    );
};

export default CarouselThumbItem;
